import service from "@/store/services/event-subsidies-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  eventSubsidy: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, eventSubsidy) => {
    state.eventSubsidy = eventSubsidy;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((eventSubsidy) => {
      commit("SET_RESOURCE", eventSubsidy);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((eventSubsidy) => {
      commit("SET_RESOURCE", eventSubsidy);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((eventSubsidy) => {
      commit("SET_RESOURCE", eventSubsidy);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  eventSubsidy: (state) => state.eventSubsidy,
  url: (state) => state.url,
};

const eventSubsidies = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default eventSubsidies;
